module.exports = __webpack_public_path__ + "static/media/inkscape.5316025f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inkscape.svg
// module id = 57
// module chunks = 0